<template>
  <section class="hero">
      <div class="hero__content container">
          <h3 class="hero__subtitle">Invest In</h3>
          <h1 class="hero__title">The First U.S.<br/>Vertically Integrated Cannabis Franchise.</h1>
          <p class="hero__description">
              We are opening the door for entrepreneurs when it comes to operating a best-in-class cannabis dispensary.
          </p>
          <a class="button"
             href="https://item9labs.app.dealmaker.tech/invitations/1aa03026-7402-4585-8c13-aef7985768b8/view"
             target="_blank">
              Invest Now
          </a>
          <br/>
          <a  class="button-outlined --text-white"
              href="https://www.sec.gov/Archives/edgar/data/1500123/000155479522000065/inlb0218form1aa.htm"
              target="_blank">
            <div class="text">View Offering Circular</div>
            <div class="line -right"></div>
            <div class="line -top"></div>
            <div class="line -left"></div>
            <div class="line -bottom"></div>
          </a>
      </div>
  </section>
</template>

<script>
export default {
  name: 'Hero',
  data () {
    return {
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/components/Hero.scss";
</style>
